<div class="modal-header">
  <h4 class="modal-title">Вход в профила</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    [disabled]="loading"
    (click)="closeModal()">
  </button>
</div>
<div class="modal-body" nzForceRepaint>
  <div class="alert alert-warning">
    <h6>Необходим е вход</h6>
    За да продължите, моля влезте в профила си. Това ще Ви осигури достъп до всички функционалности на платформата.
  </div>
  <form [formGroup]="form">
    <fieldset class="mb-4">
      <label for="emailOrUsername" class="mb-0 form-label">Имейл или потребителско име*</label>
      <input
        id="emailOrUsername"
        type="text"
        formControlName="emailOrUsername"
        class="form-control"
        placeholder="Въведете имейл или потребителско име..."
        aria-label="Имейл или потребителско име"
        [class.is-valid]="emailOrUsername?.touched && emailOrUsername?.valid"
        [class.is-invalid]="emailOrUsername?.touched && emailOrUsername?.invalid">
      <p class="invalid-feedback m-0">Задължително поле!</p>
    </fieldset>
    <fieldset class="mb-4">
      <label for="password" class="mb-0 form-label">Парола*</label>
      <input
        id="password"
        type="password"
        formControlName="password"
        class="form-control"
        placeholder="Въведете парола..."
        aria-label="Парола"
        [class.is-valid]="password?.touched && password?.valid"
        [class.is-invalid]="password?.touched && password?.invalid">
      <p class="invalid-feedback m-0">Задължително поле!</p>
    </fieldset>
  </form>
  @if (!!errorMessage) {
    <div class="pb-4 text-danger">
      {{ errorMessage }}
    </div>
  }
  <button
    (click)="onSubmit()"
    [disabled]="loading"
    class="w-100 mb-4 btn btn-nz-primary">
    @if (loading) {
      <span class="me-2 spinner-border spinner-border-sm"></span>
    }
    <span>Вход</span>
  </button>
  <p>Ако все още нямате регистрация, създайте свой профил чрез нашата
    <button class="p-0 btn btn-link text-decoration-none align-baseline"
            (click)="closeModal([appRoutes.root, appRoutes.account, appRoutes.registration])">
      Регистрационна форма.
    </button>
  </p>
  <p>Ако сте забравили паролата си, може да я възстановите чрез опцията
    <button class="ps-0 btn btn-link text-decoration-none align-baseline"
            (click)="closeModal([appRoutes.root, appRoutes.account, appRoutes.passwordRecovery])">
      Забравена парола.
    </button>
  </p>
</div>
<div class="modal-footer">
  <button
    type="button"
    [disabled]="loading"
    class="btn btn-outline-secondary"
    (click)="closeModal()">
    <span>Затвори</span>
  </button>
</div>
